import { makeBinded } from '@/proxies';
import type { OneOf } from '@/types/OneOf';

export type DialogServiceOptions = {
  title: string;
  description: string;
  successButtonText: string;
  persistent?: boolean;
} & OneOf<[{ showErrorButton?: true; errorButtonText: string; onError?: () => Promise<any> }, { showErrorButton: false }]>;

class DialogService {
  public showDialog(options: DialogServiceOptions) {
    return new Promise((res, rej) => {
      window.dispatchEvent(new CustomEvent('show-dialog', { detail: { showErrorButton: true, persistent: true, ...options } }));

      window.addEventListener(
        'success-button-click',
        (e: Event) => {
          window.removeEventListener('error-button-click', rej);
          res((e as CustomEvent).detail.result);
        },
        { once: true },
      );

      window.addEventListener(
        'error-button-click',
        () => {
          window.removeEventListener('success-button-click', res);
          rej(null);
        },
        { once: true },
      );
    });
  }

  public closeDialog() {
    window.dispatchEvent(new CustomEvent('close-dialog'));
  }
}

export const dialogService = makeBinded(DialogService);
